import React from 'react'
import { useQuery } from 'react-query'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import CategorySetting from '../components/CategorySetting'
import PolicySetting from '../components/PolicySetting'
import { getAllCategories } from 'services/api/modules/claim/category'
import { getAllApprovalRoutes, getAllClaimRoutes } from 'services/api/modules/claim/claimRoute'
import { getAllAdmins } from 'services/api/admin-accessibility'

const AdminClaimSetting = () => {
  // API for category data
  const { data: categoryData } = useQuery('adminCategoryData', async () => {
    const { data } = await getAllCategories()
    return data
  })

  // API claim approval route
  const {
    isLoading: claimPolicyIsLoading,
    data: claimPolicyData,
  } = useQuery('claimRouteData', async () => {
    const { data } = await getAllClaimRoutes()
    return data.ClaimRoute
  })

  // API approver group
  const { isLoading: approverRoutesIsLoading, data: approverRoutesData } = useQuery(
    'approverRoutesData',
    async () => {
      const { data } = await getAllApprovalRoutes()
      return data
    }
  )

  const { isLoading: adminsIsLoading, data: adminsData } = useQuery('allAdminsList', async () => {
    const { data } = await getAllAdmins()
    return data
  })

  const reimbursementAdmins =
    adminsData?.filter(
      (admin) =>
        admin?.super_admin || admin?.permissions?.some((permission) => permission?.id === 12)
    ) || []

  // all API is loading function
  const allLoading = [claimPolicyIsLoading, approverRoutesIsLoading, adminsIsLoading].some(
    (item) => item === true
  )
  return (
    <Box
      boxSizing="border-box"
      sx={{ px: { xs: 2, lg: 0 }, display: 'flex', flexDirection: 'column', gap: 2 }}
    >
      <Box id="claimCategories" sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography variant="h4" color="dark-text.main" fontWeight="bold">
            Claim categories
          </Typography>
          <Typography variant="body1" color="light-gray-text.main">
            Create and manage your company’s standard and mileage claims
          </Typography>
        </Box>
        <CategorySetting
          title="Standard claim"
          data={categoryData?.categories?.filter((category) => category?.claim_type === 'General')}
          loading={allLoading}
          type="General"
          tooltipText="Claims for general expenses like medical, education, and equipment."
        />
        <CategorySetting
          title="Mileage claim"
          data={categoryData?.categories?.filter((category) => category?.claim_type === 'Mileage')}
          loading={allLoading}
          type="Mileage"
          tooltipText="Claims for business travel mileage."
        />
      </Box>
      <Box id="approvalPolicies" sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography variant="h4" color="dark-text.main" fontWeight="bold">
            Claims approval policy
          </Typography>
          <Typography variant="body1" color="light-gray-text.main">
            Decide which approval chain applies to each claim amount.
          </Typography>
        </Box>
        <PolicySetting
          policyData={claimPolicyData}
          loading={allLoading}
          approvalRoutes={approverRoutesData}
          reimbursementAdmins={reimbursementAdmins}
        />
      </Box>
    </Box>
  )
}

export default AdminClaimSetting
